export default __webpack_public_path__ + "static/media/advertisement.f87be1e4.svg";